import _t from 'i18n!nls/front-page';

const getNewReleasesSpotlightCollectionsData = () => {
  return {
    headline: _t('Hot new releases'),
    description: '',
    ctaText: _t('Explore courses'),
    ctaTarget: '/explore/new-on-coursera',
    collectionSets: [
      {
        id: 'new-on-coursera-spotlight',
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: 'vePjWxvaRzOPzgw5b2Vapw',
      },
    ],
    linearGradientBackground: {
      angle: '86deg',
      colors: [
        'var(--cds-color-emphasis-primary-background-strong)',
        'var(--cds-color-emphasis-primary-background-default)',
        'var(--cds-color-green-300)',
      ],
      stops: [3.56, 40.71, 96.44],
    },
  };
};

export default getNewReleasesSpotlightCollectionsData;
